import React, { useEffect, useState, useRef } from 'react';
import PrimaryBtn from './GlobalComponents/primaryBtn';
import { calcualteTotalPrice, truncateString } from 'src/helpers/helperFunctions';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import { IPharmacyCartItem } from 'src/types/GlobalInterfaces';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/Store/store';
import { removeItem } from 'src/Store/cartSlice';
import { CircularProgress } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import deleteIcon from 'src/assets/images/delete-icon-cart.png';
import unOrderSartShow from 'src/assets/images/un-order-cart-show.png';
import CounterComponent from './Customer/ProductsAndServicesComponents/CounterComponent';
import FindAwardedPoints from './FindAwardedPoints';
import { tooglePleaseLogin } from 'src/Store/reducer';
import PatientDetail from './PatientDetail'
import { CURRENCY } from 'src/lib/constans';

const GlobalPharmacyCart: React.FC<{ type: "dashbaord" | "website" }> = ({ type }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { pharmacyProducts } = useSelector((store: RootState) => store.cartSlice);
    const { isLogged } = useSelector((store: RootState) => store.appReducer);

    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IPharmacyCartItem[]>([]);
    const [totalPrice, setTotalPrice] = useState<number>(0);

    const removeCartItem = (id: string) => {
        dispatch(removeItem({ category: "pharmacyProducts", productId: id }));
        setData(prev => prev?.filter(v => v?._id !== id));
    };
    const changeQuantity = (val: number, id: string) => {
        setData(prev => prev?.map(v => v._id === id ? { ...v, selectedQuantity: val } : v));
    };

    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<IPharmacyCartItem[]>({
            method: "post",
            path: "/pharma-inventory/get/products-by-ids",
            params: { ids: pharmacyProducts?.map(v => v._id) }
        })
        if (res) {
            setData(res?.map(v => ({ ...v, selectedQuantity: pharmacyProducts?.find(q => q?._id === v?._id)?.quantity || 1 })));
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        if (data?.length) {
            const total = calcualteTotalPrice(data?.map(v => ({ salePrice: Number(v?.salePrice) || 0, regularPrice: Number(v?.regularPrice) || 0, quantity: v?.selectedQuantity || 0 })));
            setTotalPrice(total);
        }
    }, [data]);
    useEffect(() => {
        if (pharmacyProducts?.length) {
            fetch();
        }
    }, []);
    const cardContainerRef = useRef<HTMLDivElement | null>(null);
    const [maxHeight, setMaxHeight] = useState<string>("auto");

    useEffect(() => {
        const adjustHeight = () => {
            const container = cardContainerRef.current;
            if (container) {
                const windowHeight = window.innerHeight; // Get the viewport height
                const offsetTop = container.getBoundingClientRect().top; // Get the container's position from the top
                const availableHeight = windowHeight - offsetTop - 20; // Calculate remaining space with some margin
                setMaxHeight(`${availableHeight}px`);
            }
        };

        adjustHeight(); // Adjust height on component mount
        window.addEventListener("resize", adjustHeight); // Adjust height on window resize

        return () => {
            window.removeEventListener("resize", adjustHeight); // Clean up on unmount
        };
    }, []);
    return (
        <div className='customer-pharmacy-card'>
            <div>
                <PatientDetail />
                <div className="customer-pharmacy-card-left">
                    <h2 className='font-Poppins-SemiBold font-size-18px theme-color-green'>{`Total: ${data?.length} Item(s)`}</h2>
                    <div ref={cardContainerRef}
                        style={{ maxHeight, overflowY: "auto", }} className='card-checkout-height-issue-resolve' >
                        {isLoader ?
                            <CircularProgress
                                size={16}
                                style={{ color: "#004540" }}
                            />
                            :
                            data?.length ?
                                data?.map(item => (
                                    <div key={item?._id} className="customer-pharmacy-card-content">
                                        <div className='customer-pharmacy-card-content-img'>
                                            <img src={`${item?.image}`} alt="" />
                                        </div>
                                        <div className='customer-pharmacy-card-content-text'>
                                            <div className='flex items-start justify-between'>
                                                <div>
                                                    <span className='font-Poppins-Medium font-size-16px theme-color-green'>{item?.brandName || ""}</span>
                                                    <Link to={type === "dashbaord" ? `/customer/pharmacy-product-detail/${item?._id}/view` : `/pharmacy-products/${item?._id}/view`} className='font-Poppins-SemiBold mb-1 font-size-16px text-[#4F6367] block underline'>{truncateString(item?.productName || "", 40)}</Link>
                                                    <p className='font-Poppins-Regular w-[90%] font-size-16px text-[#707070]'>{truncateString(item?.shortDescription || "", 100)}</p>
                                                    <div className="text-yellow-400 flex flex-row reviewstars">
                                                        {[1, 2, 3, 4, 5].map((v) => (
                                                            <FontAwesomeIcon
                                                                key={v}
                                                                className={(item?.averageRating || 0) >= v ? "text-[#facc15] font-size-20px" : "text-[#b7b6b1] font-size-20px"}
                                                                icon={faStar}
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                                <button onClick={() => removeCartItem(item?._id)}>
                                                    <img className='w-[1.5vw]' src={deleteIcon} alt="" />
                                                </button>
                                            </div>
                                            <div className='flex justify-between'>
                                                <CounterComponent
                                                    type="pharmacy"
                                                    productId={item?._id}
                                                    updateCount={(val: number) => changeQuantity(val, item?._id)}
                                                />
                                                <div className='my-list-data-price'>
                                                    <strong className='font-size-20px font-Poppins-SemiBold theme-color-green'>{CURRENCY} {item?.salePrice || item?.regularPrice}</strong>
                                                    {item?.salePrice != null && item?.salePrice > 0 && (
                                                        <strong className='font-size-13px line-through font-Poppins-Regular text-[#878787]'>{CURRENCY} {`${item?.regularPrice || "-"}`}</strong>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                // <h2 className="font-Poppins-Medium font-size-18px theme-color-green">No Items</h2>
                                <div className='parchi-icon-order2'>
                                    <img src={unOrderSartShow} alt="" />
                                    <h2 className="font-Poppins-Medium font-size-18px theme-color-green">No items in the cart</h2>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div>
                <div className="customer-pharmacy-card-right">
                    <div className='customer-pharmacy-card-right-inner'>
                        <span className='font-Poppins-Medium font-size-15px text-[#707070]'>Order Value</span>
                        <strong className='font-Poppins-SemiBold font-size-15px text-[#393535]'>{`${CURRENCY} ${totalPrice?.toFixed(2)}`}</strong>
                    </div>
                    <div className='customer-pharmacy-card-right-inner'>
                        <span className='font-Poppins-Medium font-size-15px text-[#707070]'>Express Delivery Charges</span>
                        <strong className='font-Poppins-SemiBold font-size-15px text-[#393535]'>Free</strong>
                    </div>
                    <div className='customer-pharmacy-card-right-inner theme-bg-light-seagreen'>
                        <span className='font-Poppins-SemiBold font-size-15px text-white'>Order Total</span>
                        <strong className='font-Poppins-SemiBold font-size-15px text-white'>{`${CURRENCY} ${totalPrice?.toFixed(2)}`}</strong>
                    </div>
                    <div className='customer-pharmacy-card-right-inner'>
                        <span className='font-Poppins-Medium font-size-15px text-[#707070]'>Care Credit</span>
                        <div className='text-end'>
                            <strong className='font-Poppins-SemiBold font-size-15px text-[#393535]'>
                                <FindAwardedPoints
                                    totalPrice={totalPrice}
                                />
                            </strong>
                            <p className='text-[#9B9999] font-Poppins-Regular font-size-11px'>Approximately Earn*</p>
                        </div>
                    </div>
                    <div className='p-4'>
                        {data?.length ?
                            <PrimaryBtn
                                onPress={() =>
                                    isLogged ?
                                        navigate("/customer/pharmacy-checkout")
                                        :
                                        dispatch(tooglePleaseLogin(true))
                                }
                                type="submit"
                                ButtonText="Checkout"
                                btnExtraStyle={{
                                    backgroundColor: '#004540',
                                    borderRadius: '1.5rem',
                                    margin: '0',
                                    width: '100%'
                                }}
                            />
                            : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlobalPharmacyCart;